<template>
  <div style="background: white;padding:20px;margin-bottom:20px;" v-loading="loading">
    <div style="display: flex;justify-content: space-between">
      <div>商机信息</div>
      <el-button v-if="clueInfoDetail" size="small" type="primary" @click="editClue">编辑</el-button>
    </div>
    <div v-if="clueInfoDetail">
      <div class="lables">
        <el-tag class="tag-margin" size="small" :type="clueStateTagColor">{{clueInfoDetail.clue_status}}</el-tag>
        <el-tag class="tag-margin" size="small" type="" v-if="clueInfoDetail.pre_sale =='是'">售前介入</el-tag>
        <el-tag class="tag-margin" size="small" type="info">{{clueInfoDetail.business_type}}</el-tag>
      </div>
      <div style="padding:40px 0;">
        <el-row :gutter="20">
          <el-col :span="12">
            <div class="detail-title">商机描述</div>
            <div class="detail-text">{{clueInfoDetail.clue_desc}}</div>
          </el-col>
          <el-col :span="12">
            <div class="detail-title">商机状态</div>
            <div class="detail-text"><div :style="{background:clueStateColor}" class="clue_state_0"></div>{{clueInfoDetail.clue_status}}</div>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <div class="detail-title">客户经理</div>
            <div class="detail-text">{{clueInfoDetail.client_manager}}</div>
          </el-col>
          <el-col :span="12">
            <div class="detail-title">组别</div>
            <div class="detail-text">{{clueInfoDetail.secondary_dept}}</div>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <div class="detail-title">客户名称</div>
            <div class="detail-text">{{clueInfoDetail.client_name}}</div>
          </el-col>
          <el-col :span="12">
            <div class="detail-title">计价类型</div>
            <div class="detail-text">{{clueInfoDetail.quotation_type}}</div>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <div class="detail-title">业务类型</div>
            <div class="detail-text">{{clueInfoDetail.business_type}}</div>
          </el-col>
          <el-col :span="12">
            <div class="detail-title">预计金额（万元）</div>
            <div class="detail-text">{{clueInfoDetail.estimate_amount}}</div>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <div class="detail-title">预计启动时间</div>
            <div class="detail-text">{{clueInfoDetail.estimate_start_time}}</div>
          </el-col>
          <el-col :span="12">
            <div class="detail-title">预计落地时间</div>
            <div class="detail-text">{{clueInfoDetail.estimate_close_time ? clueInfoDetail.estimate_close_time.substr(0, 7) : ''}}</div>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <div class="detail-title">竞争对手</div>
            <div class="detail-text">{{clueInfoDetail.competitor}}</div>
          </el-col>
          <el-col :span="12">
            <div class="detail-title">成功率</div>
            <el-tag v-if="clueInfoDetail.success_rate" size="small" :type="successRateColor">{{clueInfoDetail.success_rate}}</el-tag>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <div class="detail-title">客户联系人</div>
            <div class="detail-text">{{clueInfoDetail.contact}}</div>
          </el-col>
          <el-col :span="12">
            <div class="detail-title">联系方式</div>
            <div class="detail-text">{{clueInfoDetail.contact_info}}</div>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <div class="detail-title">售前是否介入</div>
            <div class="detail-text">{{clueInfoDetail.pre_sale}}</div>
          </el-col>
          <el-col :span="12">
            <div class="detail-title">售前负责人及介入时间</div>
            <div class="detail-text">{{clueInfoDetail.pre_sale_principal}}<span style="margin-left:8px;color:gray;">{{clueInfoDetail.pre_sale_time}}</span></div>
          </el-col>
        </el-row>
      </div>
      <addBusinessDialog v-model="dialogFormVisible" action="edit" :edit-form="clueInfoDetailFormat"></addBusinessDialog>
    </div>
    <el-empty v-else description="暂无数据"></el-empty>


  </div>
</template>

<script>

import {
getclueInfo
} from '../../../api/api'
import addBusinessDialog from "@/component/Business/dialog/addBusinessDialog";

export default {
  name: "BusinessInfoCard",
  props:["clue_id"],
  components:{
    addBusinessDialog
  },
  data(){
    return {
      loading:false,
      clueInfo:null,
      clueInfoDetail:null,
      dialogFormVisible:false,
      clueInfoDetailFormat:null,
    }
  },
  async mounted() {
    this.refresh(false)
  },

  computed:{
    clueStateColor(){
      let clue_status_tabs = {
        "未启动": "#909399",
        "已启动": "#67C23A",
        "已签约": "#409EFF",
        "项目取消": "#E6A23C",
        "已输单": "#F56C6C"
      }
          return clue_status_tabs[this.clueInfoDetail.clue_status] ? clue_status_tabs[this.clueInfoDetail.clue_status] : "#409EFF"
    },

    clueStateTagColor(){
      let clue_status_tabs = {
        "未启动": "info",
        "已启动": "success",
        "已签约": "",
        "项目取消": "warning",
        "已输单": "danger"
      }
      return clue_status_tabs[this.clueInfoDetail.clue_status] ? clue_status_tabs[this.clueInfoDetail.clue_status] : ""

    },
    successRateColor(){
      let rate_status_tabs = {
        "高": "success",
        "中": "warning",
        "低": "info"
      }
      return rate_status_tabs[this.clueInfoDetail.success_rate] ? rate_status_tabs[this.clueInfoDetail.success_rate] : ""
    }
  },

  watch:{
    clue_id(){
      this.refresh()
    },
    dialogFormVisible(newVal){
      if(!newVal){
        this.refresh()
        this.$emit('refreshData',true)
      }
    }
  },




  methods:{
    async getData(){

      let postData = {
        clue_id:this.clue_id
      }
      let res = await getclueInfo(postData)
      let resData = res.respData
      this.clueInfoDetail = resData.clue_info_res[0]
      this.loading = false
      // console.log('clueInfoDetail',this.clueInfoDetail)
    },

    async refresh(loading=true){
      this.loading = loading
      await this.getData()
    },
    editClue(){
      this.clueInfoDetailFormat = Object.assign(JSON.parse(JSON.stringify(this.clueInfoDetail)),{clue_id:this.clue_id})
      this.dialogFormVisible = true
    }
  }
}
</script>
<style lang="scss">
.el-row {
  margin-bottom: 40px;
  &:last-child {
    margin-bottom: 0;
  }
}
.el-col {
  border-radius: 4px;
}
.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple {
  background: #d3dce6;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border-radius: 4px;
  height:200px;
}
.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}

.lables{
  display: flex;
  .tag-margin{
    margin-right: 6px;
  }
}

.labelUnity{
  padding: 2px 10px;
  margin-right:6px;
  font-size:10px;
  border-radius: 2px;
}
.greenLabel {
  color:#7ad24e;
  background-color: rgba(122, 210, 78, 0.2);
  border: solid 1px #7ad24e;
}

.blueLabel {
  color:#51acff;
  background-color: rgba(81, 172, 255, 0.2);
  border: solid 1px #51acff;
}

.grayLabel {
  color:#a7a7a7;
  background-color: #f5f5f5;
  border: solid 1px #f5f5f5;
}

.detail-title{
  color: #a2a2a2;
  font-size:14px;
  margin-bottom:10px;
}
.detail-text{
  display: flex;
  align-items:center;
  color: black;
  font-size:14px;
}

.clue_state_0{
  width:6px;
  height:6px;
  border-radius:50%;
  margin-right:6px;
}
</style>

